import React from 'react';
import { FaSpinner, FaTimes } from 'react-icons/fa';

// Add Manager Modal
export const AddManagerModal = ({ show, newManager, setNewManager, handleCreate, submitting, onClose }) => {
  if (!show) return null;
  return (
    <div className="fixed inset-0 bg-black/80 flex items-center justify-center z-50">
      <div className="bg-[#1A2942] rounded-xl p-6 border border-[#2D5A8F] max-w-md w-full mx-4">
        <h3 className="text-xl font-bold text-white mb-4">Add New Manager</h3>
        <div className="space-y-4">
          <input type="text" placeholder="Full Name *" value={newManager.name} onChange={(e) => setNewManager({ ...newManager, name: e.target.value })} className="w-full px-4 py-3 bg-[#0F172A] border border-[#2D5A8F] rounded-lg text-white" />
          <input type="email" placeholder="Email *" value={newManager.email} onChange={(e) => setNewManager({ ...newManager, email: e.target.value })} className="w-full px-4 py-3 bg-[#0F172A] border border-[#2D5A8F] rounded-lg text-white" />
          <input type="tel" placeholder="Phone" value={newManager.phone} onChange={(e) => setNewManager({ ...newManager, phone: e.target.value })} className="w-full px-4 py-3 bg-[#0F172A] border border-[#2D5A8F] rounded-lg text-white" />
          <input type="password" placeholder="Password *" value={newManager.password} onChange={(e) => setNewManager({ ...newManager, password: e.target.value })} className="w-full px-4 py-3 bg-[#0F172A] border border-[#2D5A8F] rounded-lg text-white" />
        </div>
        <div className="flex space-x-4 mt-6">
          <button onClick={onClose} className="flex-1 py-3 bg-[#1E3A5F] text-white rounded-lg hover:bg-[#2D5A8F]">Cancel</button>
          <button onClick={handleCreate} disabled={submitting} className="flex-1 py-3 bg-gradient-to-r from-[#D4AF37] to-[#FFD700] text-[#0A1929] font-bold rounded-lg">
            {submitting ? <FaSpinner className="animate-spin mx-auto" /> : 'Create Manager'}
          </button>
        </div>
      </div>
    </div>
  );
};

// Add Content Modal
export const AddContentModal = ({ show, newContent, setNewContent, handleCreate, submitting, onClose }) => {
  if (!show) return null;
  return (
    <div className="fixed inset-0 bg-black/80 flex items-center justify-center z-50">
      <div className="bg-[#1A2942] rounded-xl p-6 border border-[#2D5A8F] max-w-lg w-full mx-4 max-h-[90vh] overflow-y-auto">
        <h3 className="text-xl font-bold text-white mb-4">Add Content</h3>
        <div className="space-y-4">
          <input type="text" placeholder="Title *" value={newContent.title} onChange={(e) => setNewContent({ ...newContent, title: e.target.value })} className="w-full px-4 py-3 bg-[#0F172A] border border-[#2D5A8F] rounded-lg text-white" />
          <textarea placeholder="Description" value={newContent.description} onChange={(e) => setNewContent({ ...newContent, description: e.target.value })} rows={3} className="w-full px-4 py-3 bg-[#0F172A] border border-[#2D5A8F] rounded-lg text-white" />
          <select value={newContent.content_type} onChange={(e) => setNewContent({ ...newContent, content_type: e.target.value })} className="w-full px-4 py-3 bg-[#0F172A] border border-[#2D5A8F] rounded-lg text-white">
            <option value="youtube">YouTube Video</option>
            <option value="gdrive">Google Drive</option>
            <option value="pdf">PDF Document</option>
            <option value="ppt">PowerPoint (PPT)</option>
            <option value="ebook">Ebook</option>
            <option value="video">Video File</option>
          </select>
          <input type="url" placeholder="URL (YouTube/Google Drive/File URL) *" value={newContent.external_url} onChange={(e) => setNewContent({ ...newContent, external_url: e.target.value })} className="w-full px-4 py-3 bg-[#0F172A] border border-[#2D5A8F] rounded-lg text-white" />
          <select value={newContent.category} onChange={(e) => setNewContent({ ...newContent, category: e.target.value })} className="w-full px-4 py-3 bg-[#0F172A] border border-[#2D5A8F] rounded-lg text-white">
            <option value="training">Training</option>
            <option value="marketing">Marketing</option>
            <option value="resources">Resources</option>
          </select>
          <div>
            <label className="text-gray-400 text-sm mb-2 block">Visible To:</label>
            <div className="flex space-x-4">
              {['advisor', 'manager', 'client'].map((role) => (
                <label key={role} className="flex items-center space-x-2 text-gray-300">
                  <input type="checkbox" checked={newContent.visible_to.includes(role)} onChange={(e) => { const roles = e.target.checked ? [...newContent.visible_to, role] : newContent.visible_to.filter((r) => r !== role); setNewContent({ ...newContent, visible_to: roles }); }} className="rounded" />
                  <span className="capitalize">{role}</span>
                </label>
              ))}
            </div>
          </div>
        </div>
        <div className="flex space-x-4 mt-6">
          <button onClick={onClose} className="flex-1 py-3 bg-[#1E3A5F] text-white rounded-lg hover:bg-[#2D5A8F]">Cancel</button>
          <button onClick={handleCreate} disabled={submitting} className="flex-1 py-3 bg-gradient-to-r from-[#D4AF37] to-[#FFD700] text-[#0A1929] font-bold rounded-lg">
            {submitting ? <FaSpinner className="animate-spin mx-auto" /> : 'Add Content'}
          </button>
        </div>
      </div>
    </div>
  );
};

// Send Notification Modal
export const SendNotificationModal = ({ show, newNotification, setNewNotification, handleSend, submitting, onClose }) => {
  if (!show) return null;
  return (
    <div className="fixed inset-0 bg-black/80 flex items-center justify-center z-50">
      <div className="bg-[#1A2942] rounded-xl p-6 border border-[#2D5A8F] max-w-lg w-full mx-4">
        <h3 className="text-xl font-bold text-white mb-4">Send Notification</h3>
        <div className="space-y-4">
          <input type="text" placeholder="Title *" value={newNotification.title} onChange={(e) => setNewNotification({ ...newNotification, title: e.target.value })} className="w-full px-4 py-3 bg-[#0F172A] border border-[#2D5A8F] rounded-lg text-white" />
          <textarea placeholder="Message *" value={newNotification.message} onChange={(e) => setNewNotification({ ...newNotification, message: e.target.value })} rows={4} className="w-full px-4 py-3 bg-[#0F172A] border border-[#2D5A8F] rounded-lg text-white" />
          <select value={newNotification.notification_type} onChange={(e) => setNewNotification({ ...newNotification, notification_type: e.target.value })} className="w-full px-4 py-3 bg-[#0F172A] border border-[#2D5A8F] rounded-lg text-white">
            <option value="info">Info</option>
            <option value="warning">Warning</option>
            <option value="success">Success</option>
            <option value="announcement">Announcement</option>
          </select>
          <div>
            <label className="text-gray-400 text-sm mb-2 block">Send To:</label>
            <div className="flex space-x-4">
              {['advisor', 'manager', 'client'].map((role) => (
                <label key={role} className="flex items-center space-x-2 text-gray-300">
                  <input type="checkbox" checked={newNotification.target_roles.includes(role)} onChange={(e) => { const roles = e.target.checked ? [...newNotification.target_roles, role] : newNotification.target_roles.filter((r) => r !== role); setNewNotification({ ...newNotification, target_roles: roles }); }} className="rounded" />
                  <span className="capitalize">{role}s</span>
                </label>
              ))}
            </div>
          </div>
        </div>
        <div className="flex space-x-4 mt-6">
          <button onClick={onClose} className="flex-1 py-3 bg-[#1E3A5F] text-white rounded-lg hover:bg-[#2D5A8F]">Cancel</button>
          <button onClick={handleSend} disabled={submitting} className="flex-1 py-3 bg-gradient-to-r from-[#D4AF37] to-[#FFD700] text-[#0A1929] font-bold rounded-lg">
            {submitting ? <FaSpinner className="animate-spin mx-auto" /> : 'Send'}
          </button>
        </div>
      </div>
    </div>
  );
};
